// question with jwplayer video - player's config override

export function videoQuestionSetup() {
    const videoSelector = '.js-video-question';

    if (document.querySelectorAll(videoSelector).length !== 1) { return; }

    return setTimeout(function () {
        const videoQuestionData = document.querySelector(videoSelector);
        const id = document.querySelector('.jwplayer')
            ? document.querySelector('.jwplayer').getAttribute('id')
            : undefined;
        const config = jwplayer(id).getConfig();
        let customParameters = [];

        for (let i = 0; i < videoQuestionData.attributes.length; i++) {
            let attr = videoQuestionData.attributes[i];
            if (/^data-/.test(attr.nodeName)) {
                customParameters.push(attr.nodeName.replace(/^data-/, '') + "=" + attr.nodeValue);
            }
        }

        if (config) {
            let params = customParameters.join('&');
            params = params.trim().replace(/^\&+|\&+$/g, '');
            const custParams = params ? '&cust_params=' + encodeURIComponent(params) : '';

            if ((typeof config.advertising !== 'undefined') && (typeof config.advertising.schedule === 'object')) {
                config.advertising.schedule[0].tag = config.advertising.schedule[0].tag + custParams;
            }
            
            if (typeof config.playlist === 'string') {
                config.playlist = config.playlist.split('?')[0];
            } else {
                config.playlist[0].recommendations = config.playlist[0].recommendations.split('?')[0];
            }

            jwplayer(id).setup(config);
        }
    }
    , 300);
}